<script setup lang="ts">
defineProps<{ title: string }>();
</script>

<template>
  <h3 :class="$style.title">{{ title }}</h3>
</template>

<style lang="scss" module>
.title {
  font-size: 16px;
  font-weight: bold;
}
</style>
